import React, { useEffect, useState } from 'react'

import Banners from '../components/Banner';
import Loader from '../components/loader'
import Ringtheme from '../components/Ringsec';
import Explore from '../components/ExploreWide';
import Craftsession from '../components/CraftMission';
import Aboutsbannersec from '../components/AboutsBanner';
import Customer from '../components/CustomerServices';



function Home() {
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState(null)
  const [testimonialContent, setTestimonialContent] = useState(null)
  const fetchContent = async () => {
    setLoading(true)
    const response = await fetch('/api/cms/home/fetch', {
      method: 'POST'
    })
    const result = await response.json()
    setContent(result.content)
    setLoading(false)
  }
  const fetchTestimonials = async () => {
    setLoading(true)
    const response = await fetch('/api/cms/testimonial/fetch', {
      method: 'POST'
    })
    const result = await response.json()
    setTestimonialContent(result.content)
    setLoading(false)
  }
  useEffect(() => {
    fetchContent()
    fetchTestimonials()
  }, [])
  return (
    <div>
      {
        loading ? <Loader /> :
          <div className="App">
            <Banners data={content?.banner} />
            <Ringtheme title={content?.sec2Title} />
            <Explore data={content?.categorySection} />
            <Craftsession data={content?.section4} />
            <Aboutsbannersec data={content?.section5} />
            <Customer data={testimonialContent} />
          </div>
      }

    </div>
  )
}

export default Home
